"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.group.dashboards.view", {
        url:
            "/:period/:date?source&startDate&comparationDate&comparationPeriod&otherPeriod&scenario&scenarioCompare&filterGroup&projection&budget&comparationActive&allMonths",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-dashboards" */ "../../company/dashboards/dashboards.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.dashboards")
            );
        },
        params: {
            comparationDate: { value: null, dynamic: true },
            source: { value: null, dynamic: true },
            startDate: { value: null, dynamic: true },
            comparationPeriod: { value: null, dynamic: true },
            otherPeriod: { value: null, dynamic: true },
            date: { value: null, dynamic: true },
            period: { value: null, dynamic: true },
            scenario: { value: null, dynamic: true },
            scenarioCompare: { value: null, dynamic: true },
            filterGroup: { value: null, dynamic: true },
            // O `urlRedirect` do dashboard manda estes quatro em toda troca de periodo. Sem
            // declara-los aqui o UI-Router os descarta em silencio, e no grupo o orcamento ou a
            // projecao escolhidos na Analise Plus -- e a comparacao -- se perdiam no primeiro F5.
            projection: { value: null, dynamic: true },
            budget: { value: null, dynamic: true },
            comparationActive: { value: null, dynamic: true },
            allMonths: { value: null, dynamic: true }
        },
        views: {
            "admin@nucont.accounting": {
                component: "dashboardsComponent",
                bindings: { companyData: "groupData" }
            }
        },
        data: {
            layoutConfig: {
                model: "LayoutConfigModel5",
                ignore: { object: "headerConfig", path: "title" },
                setAttrs: [
                    {
                        object: "headerConfig",
                        path: "moduleTitle.text",
                        value: "Dashboards"
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.description",
                        value: "Acompanhe os indicadores consolidados de todas as empresas do grupo."
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.enabled",
                        value: true
                    }
                ]
            }
        }
    });
}
